// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__n_snW","container":"styles_container__1PBLX","title":"styles_title__1pcaw","wrapper":"styles_wrapper__2Ubod","answer":"styles_answer__267dJ"};